<template lang="html">
  <div class="cw-segment-control">
    <a
      v-for="(segment, idx) in segments"
      :key="segment"
      class="button is-primary is-medium"
      :class="{ 'is-selected': selected.indexOf(idx) > -1 }"
      type="button"
      name="button"
      @click="selectedSegment(idx)"
    >
      {{ segment }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'cw-segment-control',
  // share common functionality with component mixins
  mixins: [],
  props: {
    segments: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    multipleSelection: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  // variables
  data() {
    return {};
  },
  computed: {},
  components: {},
  // methods
  watch: {},
  methods: {
    selectedSegment(idx) {
      let selected = this.selected;

      if (this.multipleSelection) {
        let existing = selected.indexOf(idx);
        if (existing > -1) {
          selected.splice(existing, 1);
        } else {
          selected.push(idx);
        }
      } else {
        selected = [idx];
      }
      let s = this.multipleSelection ? selected : selected[0];
      this.$emit('update:selected', s);
    },
  },
};
</script>

<style lang="stylus" scoped>

$primary = #f00
$primary-invert = #fff

.cw-segment-control {
  border: 3px solid $primary
  // display: flex
  border-radius: 999px
  display: inline-block;

  a.button {
    flex: 1
    border: none
    background: transparent
    color: $primary
    border-radius: 0
  }

  a.button:last-of-type {
    margin-right: 0
    border-radius: 0 999px 999px 0
  }
  a.button:first-of-type {
    margin-left: 0
    border-radius: 999px 0 0 999px

  }

  a.button.is-selected {
    background-color: $primary
    color: $primary-invert
  }
}
</style>
